const AUTO_RESUME_KEY = 'tonique_auto_resume_playback';

export interface AutoResumeData {
  playerId: number
  channel: number
  stationId?: number
  timestamp: number
}

export const saveAutoResumePlayback = (data: Omit<AutoResumeData, 'timestamp'>): void => {
  try {
    const payload: AutoResumeData = {
      ...data,
      timestamp: Date.now()
    };
    window.sessionStorage.setItem(AUTO_RESUME_KEY, JSON.stringify(payload));
  } catch (e) {
    console.warn('Could not save auto-resume state', e);
  }
};

export const getAndClearAutoResumePlayback = (): AutoResumeData | null => {
  try {
    const raw = window.sessionStorage.getItem(AUTO_RESUME_KEY);
    if (!raw) {
      return null;
    }
    window.sessionStorage.removeItem(AUTO_RESUME_KEY);
    const parsed = JSON.parse(raw) as AutoResumeData;
    // Discard if older than 5 minutes
    if (Date.now() - parsed.timestamp < 5 * 60 * 1000) {
      return parsed;
    }
  } catch (e) {
    console.warn('Could not read auto-resume state', e);
  }
  return null;
};
